import { useMediaQuery } from '@react-hook/media-query';
import { breakpoints } from '../styles/media';

const useScreenSize = () => {

    const breakpoint=  {
        xs: '568px',
        s: '768px',
        m: '1024px',
        l: '1200px',
        xl: '1600px',
        xxl: '2000px'
    }

  const isMobile = useMediaQuery(`(max-width: ${breakpoint.xs})`);
  // Define other breakpoints here as needed

  const isSmallTablet = useMediaQuery(`(max-width: ${breakpoint.s})`);
  // Define other breakpoints here as needed

  const isTablet = useMediaQuery(`(max-width: ${breakpoint.m})`);
  // Define other breakpoints here as needed


  // Wide enough that the page title moves into the header (media.laptop).
  const isWide = useMediaQuery(`(min-width: ${breakpoints.laptop}px)`);

  return {isMobile, isSmallTablet, isTablet, isWide};
};

export default useScreenSize;
